import { useState } from 'react';

function detectIsInIframe(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function useIsInIframe(): boolean {
  const [isInIframe] = useState(detectIsInIframe);
  return isInIframe;
}
